// extracted by mini-css-extract-plugin
export default {"triangle":"t+88Z","outer":"bwRL5","inner":"mmun+","right":"ji8Ez","left":"TS43a"};